<template>
	<div class="dis-fle ali-cen jus-end">
		<el-pagination v-bind="$props" :current-page="currentPage" :page-size="pageSize" :total="total" layout="prev, pager, next"
			@current-change="onCurrentChange">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: "PaginationWrapper",
	props: {
		currentPage: {      // 当前页
			type: Number,
			default: 1
		},
		pageSize: {         // 每页条数
			type: Number,
			default: 10
		},
		total: {            // 数据总条数
			type: Number,
			required: true
		}
	},
	methods: {
		onCurrentChange(val) {
			this.$emit("update:currentPage", val);   // 双向绑定
			this.$emit("current-change", val);       // 透传事件
		},
		// onSizeChange(val) {
		//   this.$emit("update:pageSize", val);      // 双向绑定
		//   this.$emit("size-change", val);          // 透传事件
		// }
	}
};
</script>
